document.addEventListener('input', (event) => {
  const control = event.target;
  if (!(control instanceof HTMLSelectElement)) return;
  if (control.id !== 'SortBy' || control.form?.id !== 'FacetSortDrawerForm') return;
  if (!document.body.classList.contains('neo-collection')) return;
  event.stopImmediatePropagation();
  const destination = new URL(window.location.href);
  destination.searchParams.set('sort_by', control.value);
  destination.searchParams.delete('page');
  window.location.assign(destination.href);
}, true);
